import { domainEvent, DomainEvent, MessageName } from "@lookiero/messaging";

const GAME_PLAYED = "game_played";

interface GamePlayedPayload {
  readonly aggregateId: string;
}

interface GamePlayed extends DomainEvent<typeof GAME_PLAYED>, GamePlayedPayload {}

interface GamePlayedFunction {
  (payload: GamePlayedPayload): GamePlayed;
}

const gamePlayed: GamePlayedFunction = ({ aggregateId }) => domainEvent({ aggregateId, name: GAME_PLAYED });

const isGamePlayed = (event: DomainEvent<MessageName>): event is GamePlayed => event.name === GAME_PLAYED;

export type { GamePlayed };
export { GAME_PLAYED, isGamePlayed, gamePlayed };
